module.exports = __webpack_public_path__ + "static/media/EOS-BNB.e629a493.svg";